var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "cliente-creditos"
  }, [_c('FilterFields', {
    attrs: {
      "fields": [{
        type: 'text',
        label: 'Cliente',
        field: 'cliente'
      }, {
        type: 'text',
        label: 'CPF/CNPJ',
        field: 'cnpj_cpf'
      }, {
        type: 'select',
        label: 'Saldo',
        field: 'saldo',
        options: ['Com saldo', 'Sem saldo']
      }]
    }
  }), _c('div', {
    staticClass: "d-flex justify-content-end mb-4"
  }, [_c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    on: {
      "click": _vm.novoAjuste
    }
  }, [_vm._v(" Ajustar crédito ")])]), _c('TableApp', {
    ref: "clienteCreditos",
    attrs: {
      "titulo": "Crédito de Clientes",
      "api-url": "/financeiro/cliente-creditos",
      "fields": _vm.fields,
      "classFilterColumn": "clienteCreditos",
      "perPage": 10
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'cliente' ? _c('span', {
          attrs: {
            "slot": "cliente"
          },
          slot: "cliente"
        }, [_c('div', {
          staticClass: "font-weight-bolder text-dark-75"
        }, [_vm._v(" " + _vm._s(props.rowData.pessoa ? props.rowData.pessoa.nome : "-") + " ")]), _c('div', {
          staticClass: "text-muted"
        }, [_vm._v(" " + _vm._s(props.rowData.pessoa ? _vm.formatCpfCnpj(props.rowData.pessoa.cnpj_cpf) : "") + " ")])]) : _vm._e(), props.field == 'saldo' ? _c('span', {
          attrs: {
            "slot": "saldo"
          },
          slot: "saldo"
        }, [_c('span', {
          staticClass: "label label-lg label-inline label-light-primary"
        }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(props.rowData.saldo, 2)) + " ")])]) : _vm._e(), props.field == 'updated_at' ? _c('span', {
          attrs: {
            "slot": "updated_at"
          },
          slot: "updated_at"
        }, [_c('span', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(_vm.formatDate(props.rowData.updated_at)) + " ")])]) : _vm._e(), props.field == 'actions' ? _c('span', {
          attrs: {
            "slot": "actions"
          },
          slot: "actions"
        }, [_c('div', {
          staticClass: "row-actions",
          staticStyle: {
            "text-align": "right !important"
          }
        }, [_c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: 'Extrato',
            expression: "'Extrato'"
          }],
          staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.abrirExtrato(props.rowData);
            }
          }
        }, [_c('Eye', {
          attrs: {
            "size": 16
          }
        })], 1), _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: 'Editar saldo',
            expression: "'Editar saldo'"
          }],
          staticClass: "btn btn-sm btn-primary btn-hover-primary btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.abrirAjuste(props.rowData);
            }
          }
        }, [_c('Pencil', {
          attrs: {
            "size": 16
          }
        })], 1)])]) : _vm._e()];
      }
    }])
  }), _c('b-modal', {
    attrs: {
      "id": "modal-ajuste-credito",
      "title": "Ajustar crédito do cliente",
      "centered": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var cancel = _ref.cancel;
        return [_c('b-button', {
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v("Cancelar")]), _c('b-button', {
          ref: "salvar-ajuste-credito",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.salvarAjuste
          }
        }, [_vm._v(" Salvar ajuste ")])];
      }
    }])
  }, [_c('b-form-group', {
    attrs: {
      "label": "Cliente",
      "label-for": "cliente"
    }
  }, [_c('VueSelect', {
    ref: "clienteCredito",
    attrs: {
      "filterable": false,
      "label": "nome",
      "options": _vm.clientes
    },
    on: {
      "search": _vm.onSearchCliente,
      "input": _vm.setCliente
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(_vm._s(option.codigo) + " - " + _vm._s(option.nome))])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(_vm._s(option.nome))])];
      }
    }]),
    model: {
      value: _vm.clienteSelecionado,
      callback: function callback($$v) {
        _vm.clienteSelecionado = $$v;
      },
      expression: "clienteSelecionado"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome do cliente ")])], 2)], 1), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Saldo atual",
      "label-for": "saldoAtual"
    }
  }, [_c('b-form-input', {
    attrs: {
      "value": 'R$ ' + _vm.numberToReal(_vm.saldoAtual, 2),
      "disabled": ""
    }
  })], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Novo saldo",
      "label-for": "novoSaldo"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "novoSaldo",
      "type": "number",
      "min": "0",
      "step": "0.01"
    },
    model: {
      value: _vm.ajuste.saldo,
      callback: function callback($$v) {
        _vm.$set(_vm.ajuste, "saldo", _vm._n($$v));
      },
      expression: "ajuste.saldo"
    }
  })], 1)], 1)], 1), _vm.valorAumentoAjuste > 0 ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "info"
    }
  }, [_vm._v(" Será gerado um novo voucher de R$ " + _vm._s(_vm.numberToReal(_vm.valorAumentoAjuste, 2)) + ". ")]) : _vm._e(), _vm.valorReducaoAjuste > 0 ? _c('div', [_c('b-alert', {
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, [_vm._v(" Selecione o voucher que será consumido pelo ajuste. ")]), _c('b-form-group', {
    attrs: {
      "label": "Voucher para baixa",
      "label-for": "voucherAjuste"
    }
  }, [_c('VueSelect', {
    attrs: {
      "label": "codigo_voucher",
      "options": _vm.vouchersSuficientesAjuste
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.codigo_voucher) + " - R$ " + _vm._s(_vm.numberToReal(option.saldo, 2)) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.codigo_voucher) + " - R$ " + _vm._s(_vm.numberToReal(option.saldo, 2)) + " ")])];
      }
    }], null, false, 92274020),
    model: {
      value: _vm.ajusteVoucherSelecionado,
      callback: function callback($$v) {
        _vm.ajusteVoucherSelecionado = $$v;
      },
      expression: "ajusteVoucherSelecionado"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Nenhum voucher com saldo suficiente para este ajuste. ")])], 2)], 1), _vm.valorTrocoAjuste > 0 && _vm.ajusteVoucherSelecionado ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "info"
    }
  }, [_vm._v(" Este ajuste vai gerar um novo voucher de troco de R$ " + _vm._s(_vm.numberToReal(_vm.valorTrocoAjuste, 2)) + ". ")]) : _vm._e()], 1) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label": "Motivo do ajuste",
      "label-for": "descricao"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "descricao",
      "rows": "3",
      "placeholder": "Ex.: acerto manual, conferência de voucher, ajuste administrativo"
    },
    model: {
      value: _vm.ajuste.descricao,
      callback: function callback($$v) {
        _vm.$set(_vm.ajuste, "descricao", $$v);
      },
      expression: "ajuste.descricao"
    }
  })], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-extrato-credito",
      "title": "Extrato de crédito",
      "size": "xl",
      "centered": "",
      "ok-only": "",
      "ok-title": "Fechar"
    }
  }, [_vm.extratoCliente ? _c('div', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "font-weight-bolder text-dark-75"
  }, [_vm._v(_vm._s(_vm.extratoCliente.nome))]), _c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.formatCpfCnpj(_vm.extratoCliente.cnpj_cpf)))])]) : _vm._e(), _c('div', {
    staticClass: "extrato-saldo-card mb-5"
  }, [_c('div', [_c('div', {
    staticClass: "extrato-saldo-label"
  }, [_vm._v("Saldo atual do cliente")]), _c('div', {
    staticClass: "extrato-saldo-valor"
  }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(_vm.extratoSaldoCliente, 2)) + " ")]), _c('div', {
    staticClass: "extrato-saldo-info"
  }, [_vm._v(" Valor disponível para uso em vendas e abatimentos. ")])])]), _c('b-table', {
    attrs: {
      "items": _vm.extrato,
      "fields": _vm.extratoFields,
      "small": "",
      "responsive": "",
      "bordered": "",
      "show-empty": "",
      "empty-text": "Nenhum movimento encontrado."
    },
    scopedSlots: _vm._u([{
      key: "cell(created_at)",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(_vm.formatDate(item.created_at)) + " ")];
      }
    }, {
      key: "cell(tipo)",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('span', {
          class: item.tipo == 'E' ? 'label label-inline label-light-success' : 'label label-inline label-light-danger'
        }, [_vm._v(" " + _vm._s(item.tipo == "E" ? "Entrada" : "Saída") + " ")])];
      }
    }, {
      key: "cell(valor)",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_vm._v(" R$ " + _vm._s(_vm.numberToReal(item.valor, 2)) + " ")];
      }
    }, {
      key: "cell(status_voucher)",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_c('span', {
          class: _vm.classeStatusVoucher(item)
        }, [_vm._v(" " + _vm._s(_vm.statusVoucher(item)) + " ")])];
      }
    }, {
      key: "cell(codigo_voucher)",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [_vm._v(" " + _vm._s(_vm.codigoVoucherMovimento(item)) + " ")];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(_ref7) {
        var item = _ref7.item;
        return [_vm.statusVoucher(item) === 'Ativo' ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: {
              title: 'Imprimir voucher',
              boundary: 'window'
            },
            expression: "{ title: 'Imprimir voucher', boundary: 'window' }"
          }],
          staticClass: "btn btn-sm btn-info btn-hover-info btn-icon",
          on: {
            "click": function click($event) {
              return _vm.imprimirVoucherAtivo(item);
            }
          }
        }, [_c('PrintIcon', {
          attrs: {
            "size": 16
          }
        })], 1) : _vm._e()];
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };